import {useEffect} from "react";

export default function EvalListTab({ wrkDclrList, listDatas, setListDatas, evalListCheckHandler, selectedEvalList, srvCheckHandler }: any) {
  useEffect(() => {
    if(listDatas.length === 0) {
      setListDatas(wrkDclrList)
    }
  }, [])
  return (<div className='flex flex-col mt-15 md:mt-[37px]'>
    <p className='mt-35 ml-8 font-preBold text-17 md:ml-[20px] md:text-42'>금일 작업을 선택해 주세요.</p>
    {listDatas.length !== 0 &&
        listDatas.map((e: any, idx: number) => {
          return (<div key={idx} onClick={() => evalListCheckHandler(e.wrkDclrSeq)}
                       className={selectedEvalList.includes(e.wrkDclrSeq) ? 'mt-15 md:mt-[42px] border border-point w-full h-90 md:h-[225px] rounded-[5px] md:rounded-[12px] text-15 leading-18 md:text-37 md:leading-45 font-preBold text-point flex flex-col justify-center pl-13 md:pl-[32px]'
                           : 'mt-15 md:mt-[42px]  border border-[#D9D9D9] w-full h-90 md:h-[225px] rounded-[5px] md:rounded-[12px] text-15 leading-18 md:text-37 md:leading-45 text-[#9C9C9B] font-preLight flex flex-col justify-center pl-13 md:pl-[32px]'}>
            <p>{e.evntNm}</p>
            <p className='font-preLight mt-9 md:mt-[22px]'>{e.wrkInfo}</p>
          </div>)
        })}
  </div>)
};